import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpDataService } from './http-data.service';
import { Distributor } from 'core/models/distributor';
import { TranslateService } from '@ngx-translate/core';
import { catchError, map } from 'rxjs/operators';
import { TYPES } from 'app/distributors/assets/constants';

@Injectable()
export class DistributorsService extends HttpDataService {
  constructor(protected injector: Injector, public translate: TranslateService) {
    super(injector, '/core/distributors');
  }

  getDistributor(id: string): Observable<Distributor> {
    return super.getItem(id);
  }

  purchaseBalance(distributor: Distributor, creditsData: any): Promise<any> {
    const url = `${this.baseUrl}/${distributor.id}/${
      distributor.subscriptions.credits ? 'credits' : 'users'
    }/purchases`;
    return super.postRequest(url, JSON.stringify(creditsData), this.getRequestOptions());
  }

  sellBalance(distributor: Distributor, creditsData: any): Promise<any> {
    const url = `${this.baseUrl}/${distributor.id}/${distributor.subscriptions.credits ? 'credits' : 'users'}/sales`;
    return super.postRequest(url, JSON.stringify(creditsData), this.getRequestOptions());
  }

  getTypes() {
    return TYPES.map((type) => ({ key: type, value: this.translate.instant(`distributors.${type}`) }));
  }

  public downloadPartnerCreditsReport(partnerId: string): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/${partnerId}/balance/report`, {
      responseType: 'blob'
    });
  }

  public getActiveData(partnerId: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/${partnerId}/active-data`, this.getRequestOptions()).pipe(
      map((res) => res),
      catchError((error) => this.handlePromiseError(error))
    );
  }
}
